"use strict";

module.exports = '5.4.2'; // Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.